import Logger from '../lib/logger';

class InteractiveMapMetricSelector extends HTMLElement {
  #NAME = 'InteractiveMapMetricSelector';
  #abortController;
  #country;
  #form;
  #map;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#form = this.querySelector('form#metric-form');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback > ${this.#country}`);
    this.#abortController =  new AbortController();
    const { signal } = this.#abortController;
    //
    this.#form.addEventListener('change', () => this.onChange(), { signal });
    this.onChange();
  }

  disconnectedCallback() {
    Logger.info(`${this.#NAME} > disconnectedCallback > ${this.#country}`);
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['country'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > name: ${name} > newValue: ${newValue}`);
    if (name === 'country') {
      this.#country = newValue;
      this.#map = document.querySelector(`interactive-map[country="${this.#country}"]`);
    }
  }

  onChange() {
    const entries = new FormData(this.#form).entries();
    for (const pair of entries) {
      this.#map.dataset[pair[0]] = pair[1];
    }
  }
}

customElements.define('interactive-map-metric-selector', InteractiveMapMetricSelector);